import React from "react";
import styled from "@emotion/styled";

const Nav = (props) => {
  const { title } = props;
  return (
    <StyledNav>
      <a href="/#" id="logo">
        <img
          src="https://uploads-ssl.webflow.com/5f5a32ad26d5b635d7dc724a/5f6a6d7e87ec9133cc91b836_Pathpoint%20(2).png"
          alt="logo"
          height="40px"
        />
      </a>
      <h4>
        {title}
      </h4>
    </StyledNav>
  );
};

export default Nav;

const StyledNav = styled.nav`
  background-color: #000d93;
  text-decoration: none;
  padding: 10px 7.5%;
  border-bottom: 0.5px solid #ddd;
  z-index: 999;
  position: fixed;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
